import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import useCnaeContext from '../../contexts/CnaeContext';
import useFetchCnae from '../../customHooks/UseFetchCnae';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({

  container: {
    color: theme.palette.secondary.main,
    marginTop: '16px',
    '& .MuiPaginationItem-root': {
      borderRadius: '3px',
    },
    '& .Mui-selected': {
      background: theme.palette.black.main,
      color: 'white'
    },
    '& .Mui-disabled': {
      color: theme.palette.primary.main
    }
  }

}));

export default function PaginationCnae({ setLoading }) {
  const classes = useStyles();
  const { paginationParams, valueInput, setCnaes } = useCnaeContext();
  const [currentPage, setCurrentPage] = useState(1);
  const { fetch } = useFetchCnae();

  useEffect(() => {
    setCurrentPage(1);
  }, [paginationParams]);

  async function changePage(page) {
    setLoading(true)
    const result = await fetch({
      search: valueInput,
      limit: 10,
      page: page,
      status: paginationParams.status
    });
    setCurrentPage(result.page);
    setCnaes(result.cnaes);
    setLoading(false);
  }

  return (
    <>
      <Pagination
        onChange={(_, page) => changePage(page)}
        page={currentPage}
        display={2}
        count={paginationParams.totalPages}
        shape={'round'}
        className={classes.container}
        size='medium'
        siblingCount={0}
        variant='text'
      />
    </>
  )
}

PaginationCnae.propTypes = {
  setLoading: PropTypes.func.isRequired
}
